// extracted by mini-css-extract-plugin
export var active = "_24-d";
export var blink = "_24-e";
export var container = "_24-5";
export var controls = "_24-0";
export var controlsRight = "_24-1";
export var fakeCursor = "_24-c";
export var hidden = "_24-b";
export var quillContainerSmall = "_24-7";
export var quillEditor = "_24-6";
export var quillEditorSmall = "_24-8";
export var quillFormatButtons = "_24-a";
export var quillToolbar = "_24-9";
export var removePadding = "_24-2";
export var state = "_24-3";
export var stateTitle = "_24-4";